import skillProviderHttpCommon from "../helper/skillProviderHttpCommon";

export const skillProviderLogin = (credentials) => {
  return skillProviderHttpCommon.post("skill-provider-portal/login/", credentials, {
    skipAuth: true,
  });
};

export const skillProviderGoogleLogin = (payload) => {
  return skillProviderHttpCommon.post("skill-provider-portal/google/", payload, {
    skipAuth: true,
  });
};

export const fetchSkillProviderPortalMe = () => {
  return skillProviderHttpCommon.get("skill-provider-portal/me/");
};

export const fetchSkillProviderPortalDashboard = ({ timezone = "" } = {}) => {
  const params = {};
  if (timezone) params.timezone = timezone;

  return skillProviderHttpCommon.get("skill-provider-portal/dashboard/", {
    params,
  });
};

export const fetchSkillProviderPortalProfile = () => {
  return skillProviderHttpCommon.get("skill-provider-portal/profile/");
};

export const updateSkillProviderPortalProfile = (formData) => {
  return skillProviderHttpCommon.patch("skill-provider-portal/profile/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const fetchSkillProviderPortalBookings = ({
  page = 1,
  pageSize = 20,
  status = "",
  search = "",
  month = "",
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };

  if (status) params.status = status;
  if (search) params.search = search;
  if (month) params.month = month;

  return skillProviderHttpCommon.get("skill-provider-portal/bookings/", {
    params,
  });
};

export const fetchSkillProviderPortalDashboardBookings = ({
  page = 1,
  pageSize = 10,
  search = "",
  status = "",
  period = "",
  timezone = "",
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };

  if (search) params.search = search;
  if (status) params.status = status;
  if (period) params.period = period;
  if (timezone) params.timezone = timezone;

  return skillProviderHttpCommon.get("skill-provider-portal/dashboard/bookings/", {
    params,
  });
};

export const fetchSkillProviderPortalCalendarSlots = ({
  startDate = "",
  days = 7,
  timezone = "",
} = {}) => {
  const params = { days };
  if (startDate) params.start_date = startDate;
  if (timezone) params.timezone = timezone;

  return skillProviderHttpCommon.get("skill-provider-portal/calendar/slots/", {
    params,
  });
};

export const publishSkillProviderPortalCalendarSlots = ({
  slots = [],
  startDate = "",
  days = 7,
  timezone = "",
  replaceExisting = true,
} = {}) => {
  const payload = {
    days,
    replace_existing: replaceExisting,
    slots: slots.map((slot) => ({
      date: slot.date,
      start_time: slot.start_time,
      end_time: slot.end_time,
    })),
  };
  if (startDate) payload.start_date = startDate;
  if (timezone) payload.timezone = timezone;

  return skillProviderHttpCommon.post(
    "skill-provider-portal/calendar/slots/publish/",
    payload,
  );
};

export const unpublishSkillProviderPortalCalendarSlots = ({
  slots = [],
  startDate = "",
  days = 7,
  timezone = "",
} = {}) => {
  const payload = {
    days,
    slots: slots.map((slot) => ({
      date: slot.date,
      start_time: slot.start_time,
      end_time: slot.end_time,
    })),
  };
  if (startDate) payload.start_date = startDate;
  if (timezone) payload.timezone = timezone;

  return skillProviderHttpCommon.post(
    "skill-provider-portal/calendar/slots/unpublish/",
    payload,
  );
};

export const fetchSkillProviderServiceBookings = ({
  page = 1,
  pageSize = 20,
  search = "",
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };

  if (search) params.search = search;

  return skillProviderHttpCommon.get("skill-provider-portal/service-bookings/", {
    params,
  });
};
